<template>
    <div class="client-segments">
        <h2>Client Segments</h2>
        <ul>
            <li v-for="segment in segments" :key="segment.id">
                {{ segment.name }}
            </li>
        </ul>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const segments = ref([
    { id: 1, name: 'Enterprise' },
    { id: 2, name: 'Small Business' },
    { id: 3, name: 'Individual' }
]);
</script>

<style scoped>
.client-segments {
    padding: 1rem;
}

.client-segments h2 {
    margin-bottom: 0.5rem;
}

.client-segments ul {
    list-style: none;
    padding: 0;
}

.client-segments li {
    margin-bottom: 0.25rem;
}
</style>
